import { InjectRepository } from "@nestjs/typeorm";
import { Repository, getManager } from "typeorm";
import { Injectable } from "@nestjs/common";
import { SaleBudgetEntity } from "./sale-budget.entity";
import { CommonResponse, SaleBudgetColumns} from "@gtpl/shared-models/masters";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import {SaleBudgetResponseModel} from 'libs/shared-models/masters/src'
import appSettings from "apps/services/config";
import { HrmsEmpDetService } from "@gtpl/shared-services/masters";
@Injectable()
export class SaleBudgetService {
    constructor(
    @InjectRepository(SaleBudgetEntity)
    private repo : Repository<SaleBudgetEntity>,
    private employeeService :  HrmsEmpDetService
  )
    {}
    async createSaleBudget(req : any): Promise<SaleBudgetResponseModel> {
        console.log(req,"ooppp")
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction()
            const flag = new Set<boolean>()
            const columnArray = []
            const updatedArray = req.map((obj) => {
                const updatedObj = {}
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            })
            const difference = columnArray.filter((element) => !SaleBudgetColumns.includes(element));
            console.log(difference,"difference")
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new SaleBudgetResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    if (value === "") {
                        updatedObj[key] = null;
                    } else {
                        updatedObj[key] = value;
                    }
                }
                return updatedObj;
            });
            
            // const deleteData = await transactionManager.getRepository(SaleBudgetEntity).delete({})
            // if (deleteData) {
            //     flag.add(true)
            // } else {
            //     flag.add(false)
            //     return new SaleBudgetResponseModel(false, 0, 'Something went wrong in data deletion')
            // }
            for (const data of convertedData) {
                console.log(data);
const salePerson = await this.employeeService.getActiveEmployeesByName({employeeName:data.SalePerson})
                if (data.NoOfContainers != null) {

                    const entity = new SaleBudgetEntity()
         entity.createdUser = req.createdUser
         entity.updatedUser = req.updatedUser
        entity.month = data.Month
        entity.year = data.Year
        entity.noOfContainers = data.NoOfContainers
        entity.salePersonId = salePerson.data.employeeId
        // entity.procurementManagerId = 
        console.log(entity,'pppppppppppp');
                    const addSave = await transactionManager.getRepository(SaleBudgetEntity).save(entity)
                    
                    if (addSave) {
                        flag.add(true)
                    } else {
                        flag.add(false)
                        await transactionManager.releaseTransaction();
                        break;
                    }
                } 
            }
            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new SaleBudgetResponseModel(true, 1, 'Data saved successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new SaleBudgetResponseModel(false, 0, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new SaleBudgetResponseModel(false, 0, 'Something went wrong');
        }
    }

    async getAllSaleBudget():Promise<CommonResponse>{  
        try{
        const manager = getManager();
        let query =`SELECT s.no_of_containers AS noOfContainer, s.month, s.year,s.sale_person_id AS salePersonId,emp.employee_name AS salePerson FROM  `+ appSettings.masters_db +`.sale_budget s
        LEFT JOIN  `+ appSettings.masters_db +`.employee_details emp ON emp.employee_id = s.sale_person_id `
        const details =await manager.query(query);
      return new CommonResponse(true, 1, 'data retrived sucessfully',details)
      
      } catch (err) {
      
        throw err
      }
      
      }

      async getBudgetVarianceReport(month?: number, year?: number): Promise<CommonResponse> {
        try {
          const manager = getManager();

     // Creating a mapping for month numbers to their corresponding month names
     const monthMapping: { [key: number]: string } = {
      1: 'January',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
      10: 'October',
      11: 'November',
      12: 'December'
    };
    
    // Get the month name from the month number
    let monthName: string | undefined;
    if (month) {
      monthName = monthMapping[month];
    }

          let query = `
            SELECT  enq.enquiry_id,enq.country_id,enq.sale_person_id,MONTH(enq.updated_at) AS confirmedBudgetMonth,
YEAR(enq.updated_at) AS confirmedBudgetYear,SUM(ep.confirmed_containers) AS total_confirmed_containers,
 sb.month,sb.year,emp.employee_name,co.country_name,sb.sale_person_id,SUM(sb.no_of_containers) AS total_budget_containers
FROM  ${appSettings.enquiry_db}.enquiries enq
LEFT JOIN  ${appSettings.enquiry_db}.enquiry_products ep ON ep.enquiry_id = enq.enquiry_id
LEFT JOIN  ${appSettings.masters_db}.sale_budget sb ON MONTH(enq.updated_at) = sb.month AND YEAR(enq.updated_at) = sb.year 
LEFT JOIN  ${appSettings.masters_db}.employee_details emp ON emp.employee_id = enq.sale_person_id
LEFT JOIN  ${appSettings.masters_db}.countries co ON co.country_id = enq.country_id
WHERE 1
${month ? ' AND MONTH(enq.updated_at) = ' + month : ''}
${year ? ' AND YEAR(enq.updated_at) = ' + year : ''}
GROUP BY enq.sale_person_id,enq.country_id,MONTH(enq.updated_at),YEAR(enq.updated_at)

UNION

SELECT  enq.enquiry_id,enq.country_id,enq.sale_person_id,MONTH(enq.updated_at) AS confirmedBudgetMonth,
YEAR(enq.updated_at) AS confirmedBudgetYear,SUM(ep.confirmed_containers) AS total_confirmed_containers,
 sb.month,sb.year,emp.employee_name as sbSalePerson,co.country_name,sb.sale_person_id ,SUM(sb.no_of_containers) AS total_budget_containers
FROM  ${appSettings.masters_db}.sale_budget sb
LEFT JOIN  ${appSettings.enquiry_db}.enquiries enq ON MONTH(enq.updated_at) = sb.month AND YEAR(enq.updated_at) = sb.year 
LEFT JOIN  ${appSettings.enquiry_db}.enquiry_products ep ON ep.enquiry_id = enq.enquiry_id
LEFT JOIN  ${appSettings.masters_db}.employee_details emp ON emp.employee_id = sb.sale_person_id
LEFT JOIN  ${appSettings.masters_db}.countries co ON co.country_id = enq.country_id
WHERE 1
${month ? ' AND sb.month = "' + month + '"' : ''}
${year ? ' AND sb.year = ' + year : ''}
GROUP BY sb.sale_person_id,sb.month,sb.year
`;
    
          const details = await manager.query(query);
          return new CommonResponse(true, 1, 'data retrieved successfully', details);
        } catch (err) {
          throw err;
        }
      }

      // async getBudgetVarianceReport(month?: number, year?: number): Promise<CommonResponse> {
      //   try {
      //     const manager = getManager();
      //     let query = `
      //       SELECT 
      //         enq.enquiry_id,
      //         enq.country_id,
      //         enq.sale_person_id,
      //         MONTH(enq.updated_at) AS confirmedBudgetMonth,
      //         YEAR(enq.updated_at) AS confirmedBudgetYear,
      //         SUM(ep.confirmed_containers) AS totalConfirmedContainers,
      //         SUM(sb.no_of_containers) AS totalBudgetContainers,
      //         sb.month,
      //         sb.year,
      //         emp.employee_name as employeeName,
      //         co.country_name as countryName
      //       FROM 
      //         ${appSettings.enquiry_db}.enquiries enq
      //       LEFT JOIN 
      //         ${appSettings.enquiry_db}.enquiry_products ep 
      //           ON ep.enquiry_id = enq.enquiry_id
      //       LEFT JOIN 
      //         ${appSettings.masters_db}.sale_budget sb 
      //           ON sb.id = enq.enquiry_id
      //       LEFT JOIN 
      //         ${appSettings.masters_db}.employee_details emp 
      //           ON emp.employee_id = enq.sale_person_id
      //       LEFT JOIN 
      //         ${appSettings.masters_db}.countries co 
      //           ON co.country_id = enq.country_id
      //     `;
    
      //     if (month || year) {
      //       query += ' WHERE 1=1'; // Add a placeholder condition to start the WHERE clause
      //       if (month) {
      //         query += ` AND MONTH(enq.updated_at) = ${month}`;
      //       }
      //       if (year) {
      //         query += ` AND YEAR(enq.updated_at) = ${year}`;
      //       }
      //     }
    
      //     query += `
      //       GROUP BY 
      //         enq.sale_person_id,
      //         confirmedBudgetMonth,
      //         confirmedBudgetYear,
      //         enq.country_id
      //     `;
    
      //     const details = await manager.query(query);
      //     return new CommonResponse(true, 1, 'data retrieved successfully', details);
      //   } catch (err) {
      //     throw err;
      //   }
      // }
    }